import { useNavigate, Link as RouterLink } from 'react-router-dom'
import Button from 'src/components/basic/Button'
import {
  DefaultTitle,
  DefaultSubtitle,
  HelperButton,
  Link,
  BeforeStartInstructionsContainer,
  BeforeStartInstruction,
  ApplicationBodyFooter,
  ApplicationBodyContainer,
  ApplicationBodyContent
} from 'src/components/application/defaultComponents'
import { tlieSources } from 'src/constants/tlie'
import ReminderCard from 'src/components/basic/ReminderCard'
import { HiOutlinePlusCircle } from 'react-icons/hi'
import { useCustomer } from 'src/context/customer'
import { useRenewal } from 'src/context/renewal'

const BeginRenewal = () => {
  const { firmData } = useCustomer()
  const navigate = useNavigate()
  const { renewalData } = useRenewal()

  const insuranceType = renewalData?.insuranceType
  

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>Welcome back{insuranceType === 'JUDGE' ? '' : ` ${firmData.name}`}. Let’s begin your{insuranceType === 'JUDGE' ? ' Judge’s' : ''} renewal.</DefaultTitle>
        <DefaultSubtitle>
          If you have any questions while completing the application, call <span style={{ color: '#3D6666' }}>1-{tlieSources.phone}</span> <br />
          or email <Link href={`mailto:${tlieSources.infoEmail}`}>{tlieSources.infoEmail}</Link>
        </DefaultSubtitle>
        <DefaultSubtitle>
          If you would like to visit your firm overview page instead of completing the renewal application at this time, <RouterLink to="/customer"><strong>click here</strong></RouterLink>.
        </DefaultSubtitle>
        <BeforeStartInstructionsContainer>
          <ReminderCard
            icon='warning'
            title='Disclaimer'
          >
            Please note this application is for a “claims made and reported” policy that provides coverage only for claims first made and reported to TLIE during the policy period.
          </ReminderCard>
          <span>You will need the following items to complete this application.</span>
          {insuranceType === 'LAWYER' ? (
            <>
              <BeforeStartInstruction>
                <HiOutlinePlusCircle />
                Confirmation of your firm’s basic information.
              </BeforeStartInstruction>
              <BeforeStartInstruction>
                <HiOutlinePlusCircle />
                Details for attorneys who have left or joined your firm in the last 12 months.
              </BeforeStartInstruction>
              <BeforeStartInstruction>
                <HiOutlinePlusCircle />
                Whether you’d like to renew with the same liability limits or request additional limit options.
              </BeforeStartInstruction>
            </>
          ) : null}
          {insuranceType === 'JUDGE' ? (
            <>
              <BeforeStartInstruction>
                <HiOutlinePlusCircle />
                Details for any grievances or claims filed in the last 12 months, if applicable.
              </BeforeStartInstruction>
              <BeforeStartInstruction>
                <HiOutlinePlusCircle />
                Confirmation of your general information
              </BeforeStartInstruction>
              <BeforeStartInstruction>
                <HiOutlinePlusCircle />
                Whether you’d like to renew your existing policy or request a new quote.
              </BeforeStartInstruction>
            </>
          ) : null}
        </BeforeStartInstructionsContainer>
      </ApplicationBodyContent>

      {insuranceType !== undefined ?
      <ApplicationBodyFooter style={{ justifyContent: 'flex-end' }}>
        
          <Button
          variant='primary'
          onClick={() => { navigate('/customer/renew/verify') }}
          minWidth={'227px'}
        >
          Begin Renewal
        </Button>
        
      </ApplicationBodyFooter> : <span></span>}
    </ApplicationBodyContainer>
  )
}

export default BeginRenewal